import React, { forwardRef, PropsWithChildren, useState, useEffect } from 'react'
import classNames from 'classnames'
import { useRadioButtonGroupContext } from '../RadioButton/RadioButton'

import styles from './TelevisionButton.module.scss'

type TelevisionButtonProps = PropsWithChildren<{
  value: string
}>

export const TelevisionButton = forwardRef<HTMLInputElement, TelevisionButtonProps>(
  ({ children, value }, ref) => {
    const getRadioProps = useRadioButtonGroupContext()
    const radioProps = getRadioProps({ value })

    const [isChecked, setIsChecked] = useState(radioProps.isChecked || false)

    useEffect(() => {
      setIsChecked(radioProps.isChecked || false)
    }, [radioProps.isChecked])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (radioProps.onChange) {
        radioProps.onChange(e)
      }
    }

    return (
      <label className={styles.container} htmlFor={radioProps.id}>
        <input
          id={radioProps.id}
          ref={ref}
          type="radio"
          name={radioProps.name}
          checked={isChecked}
          disabled={radioProps.isDisabled}
          onChange={handleChange}
          value={value}
          aria-checked={isChecked}
          style={{ position: 'absolute', opacity: 0 }}
        />
        <div
          className={classNames(styles.control, {
            [styles.checked]: isChecked,
          })}
          data-checked={isChecked ? '' : undefined}
          data-disabled={radioProps.isDisabled ? '' : undefined}
        >
          <span className={styles.label}>{children}</span>
        </div>
      </label>
    )
  }
)
